
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'

export default {
    name: 'Document',
    components: {
        EditorViewer,
    },
    props: {
        document: {
            type: Object,
            required: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        showDocumentInfo: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
}
